import  { floatDiv } from '@/util/util'
import  { validatenull } from '@/util/validate'

export function subFundListConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    index: true,
    indexLabel: "序号",
    indexWidth:40,
    refreshBtn: true,
    selection: true,
    searchShow: false,
    showSummary: true,
    column: [
      {
        label: "子基金名称",
        prop: "name",
        // prop: "fundName",
        // width: "140",
        searchLabelWidth: 90,
        slot: true,
        search: true,
      
      },  
      // {
      //   label: '审核状态',
      //   prop: 'auditState',
      //   search: true,
      //   dataType: 'string',
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   },
      //   hide:true
      // },
     
      // {
      //   label: "基金大类",
      //   prop: "fundAllType",
      //   width: '110',
      //   search: true,
      //   type: 'select',
      //   dataType: 'string',
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=fund_target_type",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   }
      // }, 
      {
        label: "设立时间",
        prop: "establishmentTime",
        width: "120", 

      },
      // {
      //   label: "基金类型",
      //   // prop: "fundType",
      //   prop:'isDirectional',
      //   width: 100,
      //   search: true,
      //   type: 'select',
      //   dataType: 'string',
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=subFund_type",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   }        
      // },
      {
        label: "出资/分配明细",
        bind: "fundDetail",
        prop: "fundDetail",
        width: 100,
        slot: true,
        hide:false
      }, 
      
      // {
      //   label: '审核状态',
      //   prop: 'auditState',
      //   search: true,
      //   dataType: 'string',
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   }
      // },
      {
        label: "出资主体",
        prop: "masterName",
        display: true,
        width: 140
      },
      {
        label: "合作方式",
        prop: "cooperateType",
        search: true,
        type: 'select',
        dataType: 'string',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=cooperate_type",
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        width:100,
      },
      {
        label: "认缴金额(万元)",
        // prop: "capitalSubscribed",
        prop:'peScale',
        display: false,
        width: 140,
        formatter: (row, value, label, column) => {
          return !validatenull(value) ? getMoney(floatDiv(value,10000)):'-' ;
        },
      },     
      {
        label: "实缴金额(万元)",
        // prop: "capitalPaid",
        prop:'totalCapitalPaid',
        display: true,
        width: 140,
        formatter: (row, value, label, column) => {
          return !validatenull(value) ? getMoney(floatDiv(value,10000)):'-' ;
        },
      },
      // {
      //   label: "基金管理人",
      //   // prop: "fundManagerName",
      //   prop:"fdManagerName",
      //   display: false,
      //   width: 150,
        
      // },
      // {
      //   label: '报告周期',
      //   prop: 'manageCycle',
      //   type: "select",
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=reportcycle_managecycle",
      //   disabled: true,
      //   props: {
      //     label: 'dictValue',
      //     value: 'dictKey'
      //   },
      //   dataType:'number',
      //   width:120,
        
      // },
      {
        label: "经办人",
        // prop: "createUserName",
        prop:'managerName',
        display: true,
        width: 50
      }]
  }
}


export function subFundAddConfig(changeNumMoneyToChinese, isvalidateMoney, validatePhone, changeThirdParty) {
  return {
    labelWidth: 160,
    emptyBtn: false,
    submitBtn: false,
    column: [


      {
        label: "子基金名称",
        prop: "name",
        span: 8,
        // overHidden: true,
        placeholder: "请输入内容",

        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      },
      {
        label: "设立时间",
        placeholder: "请输入内容",
        prop: "establishmentTime",
        type: "date",
        span: 8,
        clearable: false,
        rules: [{
          required: true,
          message: "请选择设立时间",
          trigger: "blur",
        }, ],
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
        disabled: false,
      },
      {
        label: "出资主体",
        prop: "masterName",
        span: 8,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "change",
        }, ],
        formslot: true,
        disabled: false,

      },
      {
        label: "基金认缴规模",
        prop: "peScale",
        span: 8,
        tip: "",
        tipPlacement: "top-start",
        change: ({
          value,
          column
        }) => {
          column.tip = value ?
            changeNumMoneyToChinese(value) :
            "请输入内容";
        },
        rules: [{
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
          {
            validator: isvalidateMoney,
            trigger: "blur"
          },
          
        ],
        disabled: false
      },
      {
        label: "基金实缴金额",
        prop: "totalCapitalPaid",
        span: 8,
        tip: "",
        tipPlacement: "top-start",
        change: ({
          value,
          column
        }) => {
          column.tip = value ?
            changeNumMoneyToChinese(value) :
            "请输入内容";
        },
        rules: [{
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
          {
            validator: isvalidateMoney,
            trigger: "blur"
          },
        ],
      },
      {
        label: '是否为第三方选聘',
        prop: 'isThirdParty',
        span: 8,
        type: "select",
        disabled: false,
        value:1,
        dicData: [{
            label: "是",
            value: 1,
          },
          {
            label: "否",
            value: 0,
          },

        ],
        change: ({ value, column }) => {
          if (value !== "") {
            changeThirdParty(value)
          }
          
        },

        dataType: 'number',
        rules: [{
          required: true,
          message: '请选择是否为第三方选聘',
          trigger: "change",
        }, ]

      },
      
      {
        label: "投后报告周期",
        prop: "manageCycle",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=reportcycle_managecycle",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
        disabled: false,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "change",
        }, ],
        span: 8,
      },
      {
        label: '基金类型',
        // prop: "fundType",
        prop: 'isDirectional',
        type: "select",
        span: 8,
        dataType: 'number',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=subFund_type",
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "change",
        }, ],
        disabled: false,

      },
      

      
      
      
      
      
      
      
      {
        label: "带动社会投资金额",
        prop: "allSocietyAmount",
        span: 8,
        disabled: false,
        rules: [{
          required: true,
          message: "请输入",
          trigger: "blur",
        }, ],
        tip: "",
        tipPlacement: "top-start",
        change: ({
          value,
          column
        }) => {
          column.tip = value ? changeNumMoneyToChinese(value) : "";
        },
      },
      {
        label: "合作方式",
        prop: "cooperateType",
        type: "select",
        dataType: 'number',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=cooperate_type",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        
        disabled: false,
        span: 8,
      },
      {
        label: "基金状态",
        prop: "fundState",
        type: "select",
        dataType: 'number',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=fund_state",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        disabled: false,
        span: 8,
      },
      {
        label: "投资期截止日期",
        placeholder: "请选择时间",
        prop: "investEndDate",
        type: "date",
        span: 8,
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
      },
      {
        label: "退出期截止日期",
        placeholder: "请选择时间",
        prop: "quitEndDate",
        type: "date",
        span: 8,
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
      },
      {
        label: "基金已投金额",
        prop: "allFundAmount",
        span: 8,
        disabled: true,
        placeholder: "等待生成",
        tip: "",
        tipPlacement: "top-start",
        change: ({
          value,
          column
        }) => {
          column.tip = value ? changeNumMoneyToChinese(value) : "";
        },
      },
      {
        label: "已收回金额",
        prop: "fundQuidAmount",
        disabled: true,
        span: 8,
        placeholder: "等待生成",
        tip: "",
        tipPlacement: "top-start",
        change: ({
          value,
          column
        }) => {
          column.tip = value ? changeNumMoneyToChinese(value) : "";
        },
      },
      {
        label: "管理费收取模式",
        prop: "manageIncomeType",
        type: 'textarea',
        row: true,
        span: 24,

      },
      {
        label: "基金管理人名称",
        span: 24,
        prop: "fdManagerName",
        // bind: "manager.name",
        placeholder: "请输入内容",
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],
        formslot: true,
      },
      {
        label: "成立时间",
        span: 8,
        prop: "managerEstablishmentTime",
        bind: "manager.establishmentTime",
        type: "date",
        clearable: false,
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
        disabled:true
      },
      {
        label: "所在地区",
        span: 8,
        prop: "region",
        bind: "manager.region",
        // formslot: true,
        // type: "cascader",
        disabled:true
      },
      
      {
        label: "所在地址",
        span: 8,
        prop: "address",
        bind: "manager.address",
        disabled:true
      },
      {
        label: "纳税识别号",
        prop: "creditCode",
        span: 8,
        bind: "manager.creditCode",
        placeholder: "请输入内容",
        disabled:true
      },
      {
        label: "基金协会编码",
        span: 8,
        prop: "orgCode",
        bind: "manager.orgCode",
        placeholder: "请输入内容",
        disabled:true


      },
      {
        label: "联系人",
        span: 8,
        prop: "contactPerson",
        bind: "manager.contactPerson",
        placeholder: "请输入内容",
        disabled:true
      },
      {
        label: "联系号码",
        span: 8,
        prop: "contactInfo",
        bind: "manager.contactInfo",
        // rules: [{
        //   validator: validatePhone,
        //   trigger: "blur"
        // }],
        disabled:true
      },
      {
        label: "职务信息",
        span: 8,
        prop: "duty",
        bind: "manager.duty",
        placeholder: "请输入内容",
        disabled:true
      },

    ]
  }
}

export function subFundDetailConfig(getMoney){
  return [
    {
      label: "子基金名称",
      prop: 'name',
      span: '8'
    },
    {
      label: "设立时间",
      prop: 'establishmentTime',
      span: '8'
    },
    {
      label: "出资主体",
      prop: 'masterName',
      span: '8'
    },
    {
      label: "基金认缴规模",
      prop: 'peScale',
      span: '8',
      formatter: (label, value) => {
        
        return !validatenull(value) ? getMoney(floatDiv(value,10000))+'万元':'-' ;
      },

      
    },
    {
      label: "基金实缴金额",
      prop: 'totalCapitalPaid',
      span: '8',
      formatter: (label, value) => {
        
        return !validatenull(value) ? getMoney(floatDiv(value,10000))+'万元':'-' ;
      },
    },
    {
      label: "是否为第三方选聘",
      prop: 'isThirdParty',
      span: '8',
      formatter: (label, value) => {
        
        return value==1?'是':'否'
      },
    },
    {
      label: "投后报告周期",
      prop: 'manageCycleStr',
      span: '8'
    },
    {
      label: "基金类型",
      prop: 'isDirectionalStr',
      span: '8'
    },


    {
      label: "带动社会投资金额",
      prop: 'allSocietyAmount',
      span: '8',
      formatter: (label, value) => {
        
        return !validatenull(value) ? getMoney(floatDiv(value,10000))+'万元':'-' ;
      },

      
    },
    {
      label: "合作方式",
      prop: 'cooperateTypeStr',
      span: '8'
    },
    {
      label: "基金状态",
      prop: 'fundStateStr',
      span: '8'
    },
    {
      label: "投资期截止日期",
      prop: 'investEndDate',
      span: '8'
    },
    {
      label: "退出期截止日期",
      prop: 'quitEndDate',
      span: '8'
    },
    {
      label: "基金已投金额",
      prop: 'allFundAmount',
      span: '8',
      formatter: (label, value) => {
        
        return !validatenull(value) ? getMoney(floatDiv(value,10000))+'万元':'-' ;
      },

      
    },
    {
      label: "已收回金额",
      prop: 'fundQuidAmount',
      span: '8',
      formatter: (label, value) => {
        
        return !validatenull(value) ? getMoney(floatDiv(value,10000))+'万元':'-' ;
      },

      
    },
    
    {
      label: "管理费收取模式",
      prop: 'manageIncomeType',
      type: 'textarea',
      span: '24',
      disabled:true
    },

    {
      label: "基金管理人名称",
      prop: 'fdManagerName',
      span: '24'
    },
    {
      label: "成立时间",
      prop: "manager",
      propInner: "establishmentTime",
      span: '8'
    },
    {
      label: "所在地区",
      prop: "manager",
      propInner: "region",
      span: '8'
    },
    {
      label: "所在地址",
      prop: "manager",
      propInner: "address",
      span: '8'
    },
    {
      label: "纳税识别号",
      prop: "manager",
      propInner: "creditCode",
      span: '8'
    },
    {
      label: "纳税识别号",
      prop: "manager",
      propInner: "orgCode",
      span: '8'
    },
    {
      label: "联系人",
      prop: "manager",
      propInner: "contactPerson",
      span: '8'
    },
    {
      label: "联系号码",
      prop: "manager",
      propInner: "contactInfo",
      span: '8'
    },
    {
      label: "职务信息",
      prop: "manager",
      propInner: "duty",
      span: '8'
    },
  ]
}
